import script from "./FormDesigner.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDesigner.vue?vue&type=script&setup=true&lang=js"

import "./FormDesigner.vue?vue&type=style&index=0&id=c6e34fc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6e34fc6"]])

export default __exports__